import React from 'react'
import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import ShipmentLoadingBasicDetail from "./ShipmentLoadingBasicDetail";

import { useGetShipmentLoadingDetailQuery, useUpdateShipmentLoadingMutation } from "store/services/shipmentLoadingApi";
import { ShipmentLoadingDetailContext, useShipmentLoadingDetailContext } from "contexts/ShipmentLoadingDetailContext";

import ShipmentLoadingDetailTab from "./ShipmentLoadingComponents/ShipmentLoadingDetailTab";
import { useAuth } from "hooks";


const ShipmentLoadingDetailScreen = () => {

  const { id } = useParams();
  const { isDriver } = useAuth();

  const breadcrumb = [
    { title: "Shipment Loading", path: !isDriver ? "/app/crm/shipment-loading/list" : "/app/driver/loading" },
    { title: "Shipment Loading Detail" }
  ]

  // RTK Query
  const { data: shipmentLoadingDetail, isLoading: loadingShipmentLoading, error,
  } = useGetShipmentLoadingDetailQuery(id);

  return (
    <ShipmentLoadingDetailContext.Provider value={{ shipmentLoadingDetail, loadingShipmentLoading }}>
      <BreadcrumbLayout breadcrumbs={breadcrumb}
        isBusy={loadingShipmentLoading}
        headerActions={<PageActions />} >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <ShipmentLoadingBasicDetail />
          <Divider />
          <ShipmentLoadingDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </ShipmentLoadingDetailContext.Provider>
  )
}

export default ShipmentLoadingDetailScreen;

const PageActions = () => {
  const { isDriver, isAccountAdmin } = useAuth();
  const navigate = useNavigate();


  const { shipmentLoadingDetail, loadingShipmentLoading }
    = useShipmentLoadingDetailContext();

  // RTK Query
  const [updateShipmentLoading, { isLoading: updatingShipmentLoading }]
    = useUpdateShipmentLoadingMutation();

  // methods
  const handelToggleShipmentLoadingStatus = async () => {
    try {
      await updateShipmentLoading({
        _id: shipmentLoadingDetail._id,
        isActive: !shipmentLoadingDetail.isActive,
      }).unwrap();
      toast.info(`maintenance ${shipmentLoadingDetail.isActive ? "Disable" : "Enable"} !`);
    } catch (error) {
      toast.error(error?.data.message ?? "Could Not Update Status");
    }
  }

  return (
    <>
      {!isDriver && (<div className="flex space-x-4">
        {isAccountAdmin && (<EnableDisableButton
          isActive={shipmentLoadingDetail?.isActive}
          loading={loadingShipmentLoading || updatingShipmentLoading}
          onClick={handelToggleShipmentLoadingStatus}
        />)}
        <Button startIcon={<EditOutlined />} variant="contained" onClick={() => {
          if (shipmentLoadingDetail?.freeloadingId) {
            navigate(`/app/crm/freeloading/${shipmentLoadingDetail?._id}/edit`);
          }
          else {
            navigate(`/app/crm/shipment-loading/${shipmentLoadingDetail._id}/edit`);
          }
        }}>
          Edit
        </Button>
      </div>)}
    </>
  );
};
